import React, { useEffect, useState } from 'react';
import CueMessageBroker from '../cue-message-broker/cue-message-broker';
import MessageBrokerContext from './context';
const MessageBrokerProvider = props => {
    const { userId, publishKey, subscribeKey, children } = props;
    const [cueMessageBrockerInstance, setCueMessageBrokerInstance] = useState(undefined);
    useEffect(() => {
        if (userId && !cueMessageBrockerInstance) {
            const instance = new CueMessageBroker({
                publishKey,
                subscribeKey,
                userId,
            });
            setCueMessageBrokerInstance(instance);
        }
        /* On logout, destroy instnace */
        if (cueMessageBrockerInstance && !userId) {
            cueMessageBrockerInstance.disconnect();
            setCueMessageBrokerInstance(undefined);
        }
    }, [cueMessageBrockerInstance, publishKey, subscribeKey, userId]);
    useEffect(() => {
        return () => {
            if (cueMessageBrockerInstance) {
                cueMessageBrockerInstance.disconnect();
            }
        };
    }, [cueMessageBrockerInstance]);
    return (React.createElement(MessageBrokerContext.Provider, { value: cueMessageBrockerInstance }, children));
};
export default MessageBrokerProvider;
//# sourceMappingURL=provider.js.map